import PropTypes from "prop-types";
import React, { Component } from "react";
import { Header, Icon } from "semantic-ui-react";
import { AcceptStepPanel } from "./AcceptStepPanel";
import { ChooseDocumentStepPanel } from "./ChooseDocumentStepPanel";

export class DocumentRequestStepPanels extends Component {
  render() {
    const { docReq, currentStep } = this.props;

    switch (currentStep) {
      case 0: // Select Document step
        return <ChooseDocumentStepPanel docReq={docReq} />;

      case 1: // Accept step
        return <AcceptStepPanel docReq={docReq} showProvider />;

      case 2: {
        // Completed step - wrap in curly braces
        const label = docReq.state === "ACCEPTED" ? "accepted" : "declined";
        return (
          <Header icon>
            <Icon name="check" />
            The request has been {label}.
          </Header>
        );
      }

      default:
        return <ChooseDocumentStepPanel docReq={docReq} />;
    }
  }
}

DocumentRequestStepPanels.propTypes = {
  docReq: PropTypes.object.isRequired,
  currentStep: PropTypes.number.isRequired,
};
